module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_voice03-bb08eeea7ff20d154442242110b5cbd3.jpg";